import axios from "axios";
import { shop_search_completion_keywords_path } from "@/src/web/routes";

type shopSearchCompletionKeywordsParams = {
  query?: string;
  query_type?: string;
  prefecture_id?: number,
}

export type shopSearchCompletionKeywordsResponse = {
  content: string;
  category: string;
  relation_id: number | string;
  prefecture_id: number;
}

export const shopSearchCompletionKeywords = async (params: shopSearchCompletionKeywordsParams): Promise<shopSearchCompletionKeywordsResponse[]> => {
  try {
    const response = await axios.get(shop_search_completion_keywords_path(), {params: params});
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (response.data && response.data.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return
      return response.data.map((keyword: shopSearchCompletionKeywordsResponse) => keyword);
    }
  } catch (error) {
    console.error(error);
  }
  return [];
}
